const Joi = require("joi");

const noticeSchema = (data) => {
  const schema = Joi.object({
    NoticeTitle: Joi.string()
      .trim()
      .max(30)
      // .pattern(new RegExp("^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$"))
      .required()
      .messages({ 
        // "string.pattern.base": "Please enter Title.",
        "string.empty": "Please enter Title.",
        "any.required": "Please enter Title.",
        "string.max": "Please enter Title.",
      }),

    NoticeDispaly: Joi.string()
      .trim()
      .min(1)
      .custom((value, helpers) => {
        const strippedContent = value
          .replace(/<\/?[^>]+(>|$)/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/\s+/g, "")
          .trim();

        if (!strippedContent || strippedContent.length === 0) {
          return helpers.message("Please enter Description.");
        }

        return value;
      })
      .required()
      .messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
        "string.min": "Please enter Description.",
      }),

    // NoticeDispaly: Joi.string()
    // .required()
    // .custom((value, helpers) => {
    //   try {
    //     const parsedContent = JSON.parse(value);
    //     const blocks = parsedContent?.blocks || [];

    //     // ✅ Check if all `blocks.text` are empty
    //     const isEmpty = blocks.every((block) => block.text.trim() === "");

    //     if (isEmpty) {
    //       return helpers.message("Description is required.");
    //     }
    //   } catch (error) {
    //     return helpers.message("Invalid description format.");
    //   }

    //   return value;
    // }),

    StartDate: Joi.string()
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/)
      .required()
      .messages({
        "string.pattern.base": "Please enter Start Date.",
        "string.empty": "Please enter Start Date.",
        "any.required": "Please enter Start Date.",
      }),

    EndDate: Joi.string()
      .pattern(/^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/)
      .required()
      .custom((value, helpers) => {
        const { StartDate } = helpers.state.ancestors[0];
        const start = new Date(StartDate);
        const end = new Date(value);

        if (isNaN(start.getTime()) || isNaN(end.getTime())) {
          return helpers.message("Please enter valid Date format.");
        }

        if (end < start) {
          return helpers.message(
            "End Date must be greater than or equal to Start Date."
          );
        }
        return value;
      })
      .messages({
        "string.pattern.base": "Please enter End Date.",
        "string.empty": "Please enter End Date.",
        "any.required": "Please enter End Date.",
      }),

    NoticePermissionList: Joi.array()
      .items(
        Joi.object({
          FacilityID: Joi.number().required().messages({
            "string.pattern.base": "Enter valid Notice Permission List",
            "string.empty": "Notice Permission List is required",
            "any.required": "Notice Permission List is required.",
          }),

          KiosksID: Joi.number().required().messages({
            "string.pattern.base": "Enter valid Notice Permission List",
            "string.empty": "Notice Permission List is required",
            "any.required": "Notice Permission List is required.",
          }),
        }).unknown(true)
      )
      .min(1)
      .required()
      .messages({
        "array.base": "Please select any Kiosks.",
        "array.min": "Please select any Kiosks.",
        "any.required": "Please select any Kiosks.",
      }),

    ActiveStatus: Joi.number().valid(1, 0).messages({
      "any.only": "Please select any Kiosks.",
    }),
  }).unknown(true);
  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = noticeSchema;
